import Grid from '@material-ui/core/Grid';
import { subContentColor } from '../../components/lib/Color';
import Button from "@material-ui/core/Button";
import DirectionsRunIcon from '@material-ui/icons/DirectionsRun';

type Props = {
    onBattleResultMoveButtonClick: () => void,
}

const BottomButtonArea = ({ onBattleResultMoveButtonClick }: Props) => {
    return (
        <Grid item xs={12} style={{
            textAlign: 'center',
            justifyContent: 'center',
            alignContent: 'center',
            background: subContentColor,
            marginTop: 5,
            marginLeft: 8,
            marginRight: 8
        }}>
            <Button variant="contained" color="primary" onClick={onBattleResultMoveButtonClick}>
                <DirectionsRunIcon /> バトル開始
            </Button>
        </Grid>
    );
}

export default BottomButtonArea;
